import React from 'react';
import { ProfileGroup } from 'new/elements/ProfileGroup/ProfileGroup';
import { Team } from 'new/entities/Team';

export function TeamMembers(props: Team) {
  const mapMembersToUsers = (members) => {
    return members.map((user) => {
      return {
        ...user,
        name: user.full_name || user.name || user.email,
        fullName: user.full_name || user.name || user.email,
      };
    });
  };
  return <ProfileGroup items={mapMembersToUsers(props.members)} onClickItem={() => {}} />;
}
